import { render } from "./SVGPhoto.vue?vue&type=template&id=6f4838d7"
import script from "./SVGPhoto.vue?vue&type=script&lang=js"
export * from "./SVGPhoto.vue?vue&type=script&lang=js"

import exportComponent from "/home/tachyon/wardrobe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__